<template lang="pug">
    .drag-and-drop-image-upload
        .profile-background-image-drag(@drop.prevent="dragBgFile" @dragover.prevent :style="bgImage" @click="changePhoto")
            input.bg-image-input(type="file" accept="image/*" @change="addFile" ref="inputField")
            template(v-if="!bgImageAvailable")
                svg-icon(iconId="plus" v-if="!bgFile")
                span.bg-image-description
                    span Drop you images here, or 
                    label click to browse
                span.bg-image-notice {{ imageNoticeText }}
        settings-image-actions.dragable-actions(v-if="bgImageAvailable" @deletePhoto="deletePhoto" @changePhoto="changePhoto")
</template>

<script>
export default {
    name: "drag-and-drop-image-upload",
    props: {
        intialImage: {
            type: String,
            default: null,
        },
        recommendedSizeText: {
            type: String,
            default: '1600 x 1200 (4 : 3)',
        },
    },
    data() {
        return {
            bgFile: null,
            initialImageRemoved: false,
        }
    },
    computed: {
        bgImage() {
            let url = null

            if (this.bgFile) {
                url = URL.createObjectURL(this.bgFile)
            } else if (!this.initialImageRemoved) {
                url = this.intialImage
            }

            return url ?
                { 'background-image': "url(" + url + ")", 'border': 'none' } :
                { "background-color": "#F3F3F3" }
        },
        bgImageAvailable() {
            return this.bgFile || (!this.initialImageRemoved && this.intialImage)
        },
        imageNoticeText() {
            return `${this.recommendedSizeText} recommended, up to 10MB.`
        },
    },
    methods: {
        dragBgFile(e) {
            let droppedFile = e.dataTransfer.files[0];
            if(!droppedFile) return;
            this.bgFile = droppedFile;
        },
        addFile(e) {
            let droppedFile = e.target.files[0];
            if (droppedFile) {
                this.bgFile = droppedFile
            }
            e.target.value = ''
        },
        deletePhoto() {
            if (this.bgFile) {
                this.bgFile = null
            } else {
                this.initialImageRemoved = true
            }
        },
        changePhoto() {
            this.$refs.inputField.click()
        },
    }
}
</script>
